import React, { useState } from "react"
import './FormCreateAdmin.scss'
import userAdminService from "@/api/userAdmin.service"
import Box from '@mui/material/Box';
import { generateRandomPassword, tokens, useAuth, dialCodes } from "@/utilities"
import { Header } from "@/views";
import { Button, FormControl, FormGroup, Grid, InputLabel, MenuItem, Select, TextField, Typography, useTheme, Checkbox, FormControlLabel, IconButton, InputAdornment } from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Swal from "sweetalert2";
import { UserAdminProfile, facultyProps } from "@/types";
import { UserCreationRequest } from "@/types";
import CloseIcon from '@mui/icons-material/Close';

import { getAuth } from "firebase/auth";


interface Props {
  handleChangeTab: (tab: number) => void
  adminUsers: UserAdminProfile[] | []
  faculties: facultyProps[] | null
  // setAdminUsers:  React.Dispatch<React.SetStateAction<UserAdminProfile[]>>;

}


export const FormCreateAdminFaculty = ({ handleChangeTab, faculties }: Props) => {
  const { user } = useAuth()

  // const [adminUsers, setAdminUsers] = useState<UserAdminProfile[]>([])

  const [userRegister, setUserRegister] = useState({
    email: "",
    institution: user?.userData.institute,
    phone_code_country: "+57",
    phone: "",
    name: "",
    faculty: [] as string[],
    role: "",
    password: "",
    confirmPassword: "",
    autoAssign: true
  })

  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme()
  const colors = tokens(theme.palette.mode);

  // const [faculties, setFaculties] = useState<facultyProps[] | null>([])

  const filteredFaculties = faculties;
  const [openFacultySelect, setOpenFacultySelect] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (userRegister.role === "Administrador Facultad" && (!userRegister.faculty || userRegister.faculty.length === 0)) {
      Swal.fire({
        title: "Facultad requerida",
        text: "Debe seleccionar al menos una facultad para el usuario Gestor Facultad.",
        icon: "error"
      });
      return;
    }
    try {
      // SCENARIOS 3 & 4: Check if user already exists in Firestore '/users/' collection
      const existingUser = await userAdminService.getByEmail(userRegister.email);
      if (existingUser) {
        if (existingUser.institute === user?.userData.institute) {
          Swal.fire({
            title: "Usuario ya existe",
            text: "Usuario ya existe en mi Institución",
            icon: "error"
          });
        } else {
          Swal.fire({
            title: "Usuario ya existe",
            text: "Usuario ya existe en otra Institución",
            icon: "error"
          });
        }
        return; // stop registration
      }

      const newPassword = userRegister.autoAssign ? generateRandomPassword(8) : userRegister.password;
      const authUser: UserCreationRequest = {
        displayName: userRegister.name,
        email: userRegister.email,
        password: newPassword,
        institution: userRegister.institution ?? 'unknown',
        role: userRegister.role,
        needActivation: true
      };
      // Get the current user's ID token
      const auth = getAuth();
      const currentUser = auth.currentUser;
      const idToken = await currentUser?.getIdToken();
      // console.log("ID Token:", idToken);
      const url = "https://us-central1-guia-universitaria-dev.cloudfunctions.net/createUserAdminV2";
      // console.log("Creating user with data:", authUser);
      // console.log("Using URL:", url);
      const createAdmin = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${idToken}`,
        },
        body: JSON.stringify(authUser)
      }).then((response) => response.json())
      // console.log("Create User response", createAdmin);
      if (createAdmin.status && (createAdmin.status === "200" || createAdmin.status === "201")) {
        let uidFaculty: string | string[] = [];
        let facultyName: string | string[] = [];
        
        if (userRegister.role !== "Administrador IES") {
          facultyName = Array.isArray(userRegister.faculty) ? userRegister.faculty : (userRegister.faculty ? [userRegister.faculty] : []);
          uidFaculty = (facultyName as string[]).map((fName) => {
            const matchedFaculty = faculties?.find((faculty) => faculty.name === fName);
            return matchedFaculty?.id || "";
          }).filter(Boolean);
        }

        // Determine if user already existed in Firebase Authentication (Active Directory)
        const isAlreadyExists = !!(createAdmin.alreadyExists || createAdmin.exists || createAdmin.response?.alreadyExists || createAdmin.response?.exists);

        const profileData = {
          uid: createAdmin.response,
          displayName: userRegister.name,
          email: userRegister.email,
          emailVerified: false,
          phoneNumber: userRegister.phone,
          active: true,
          institute: userRegister.institution,
          ref: `/institutes/${userRegister.institution}`,
          role: userRegister.role,
          faculty: facultyName,
          uidFaculty: uidFaculty,
          mustChangePassword: !isAlreadyExists,
        };
        const savedInFirestore = await userAdminService.saveUserProfile(profileData, createAdmin.response);

        if (savedInFirestore) {
          console.log("Registro exitoso en Firebase Authentication y Firestore");

          if (isAlreadyExists) {
            // SCENARIO 2: User existed in Active Directory, created in the IES, password not modified.
            Swal.fire({
              title: "Usuario registrado en la IES",
              text: "El usuario ya existe y ha sido asociado a la IES. La contraseña no ha sido modificada.",
              icon: "success",
              confirmButtonText: "Ir a lista de usuarios"
            }).then((result) => {
              if (result.isConfirmed) {
                handleChangeTab(1);
              }
            });
          } else {
            // SCENARIO 1: User did not exist in Active Directory, temporary password generated.
            Swal.fire({
              title: "Usuario creado satisfactoriamente",
              icon: "success",
              html: `
                <style>
                  .swal2-validation-message {
                    background-color: #f0fdf4 !important;
                    color: #166534 !important;
                    margin-top: 10px !important;
                  }
                  .swal2-validation-message::before {
                    background-color: #22c55e !important;
                  }
                </style>
                <div style="text-align: left; margin-top: 20px;">
                  <p><strong>Correo electrónico:</strong></p>
                  <div style="display: flex; align-items: center; gap: 10px; background: #f4f4f4; padding: 10px; border-radius: 5px; margin-bottom: 15px;">
                    <span style="flex-grow: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${userRegister.email}</span>
                    <button id="copyEmail" class="swal2-confirm swal2-styled" style="margin: 0; padding: 5px 10px; font-size: 14px;">Copiar</button>
                  </div>
                  <p><strong>Contraseña:</strong></p>
                  <div style="display: flex; align-items: center; gap: 10px; background: #f4f4f4; padding: 10px; border-radius: 5px;">
                    <input type="password" id="swalPassword" value="${newPassword}" readonly style="flex-grow: 1; border: none; background: transparent; font-size: 16px; width: 50%"/>
                    <button id="toggleSwalPsw" class="swal2-confirm swal2-styled" style="margin: 0; padding: 5px 10px; font-size: 14px; background-color: #757575">Ver</button>
                    <button id="copyPsw" class="swal2-confirm swal2-styled" style="margin: 0; padding: 5px 10px; font-size: 14px;">Copiar</button>
                  </div>
                  <p style="margin-top: 15px; font-size: 14px; color: #d32f2f;"><strong>Nota:</strong> Esta es una clave temporal. El usuario deberá cambiarla al iniciar sesión.</p>
                </div>
              `,
              showConfirmButton: true,
              confirmButtonText: "Ir a lista de usuarios",
              didOpen: () => {
                const copyEmailBtn = document.getElementById('copyEmail');
                const copyPswBtn = document.getElementById('copyPsw');
                const togglePswBtn = document.getElementById('toggleSwalPsw');
                const pswInput = document.getElementById('swalPassword') as HTMLInputElement;

                copyEmailBtn?.addEventListener('click', () => {
                  navigator.clipboard.writeText(userRegister.email);
                  Swal.showValidationMessage('Correo copiado');
                  setTimeout(() => Swal.resetValidationMessage(), 1500);
                });

                copyPswBtn?.addEventListener('click', () => {
                  navigator.clipboard.writeText(newPassword);
                  Swal.showValidationMessage('Contraseña copiada');
                  setTimeout(() => Swal.resetValidationMessage(), 1500);
                });

                togglePswBtn?.addEventListener('click', () => {
                  if (pswInput.type === "password") {
                    pswInput.type = "text";
                    togglePswBtn.textContent = "Ocultar";
                  } else {
                    pswInput.type = "password";
                    togglePswBtn.textContent = "Ver";
                  }
                });
              }
            }).then((result) => {
              if (result.isConfirmed) {
                handleChangeTab(1);
              }
            });
          }

          setUserRegister({
            email: "",
            institution: user?.userData.institute,
            phone_code_country: "+57",
            phone: "",
            name: "",
            faculty: [] as string[],
            role: "",
            password: "",
            confirmPassword: "",
            autoAssign: true
          });

        } else {
          console.error("Error al guardar en Firestore");
          Swal.fire({
            title: "Error",
            text: "No se pudo guardar el perfil en la base de datos",
            icon: "error"
          });
        }
      } else {
        Swal.fire({
          title: "Error al crear usuario",
          text: createAdmin.response || "Ocurrió un error inesperado",
          icon: "error"
        });
      }
    } catch (error: any) {
      console.error(error);
      Swal.fire({
        title: "Error",
        text: error.message || "Error de conexión con el servidor",
        icon: "error"
      });
    }
  }
  const [emailError, setEmailError] = React.useState(false);
  const [phoneError, setPhoneError] = React.useState(false)

  const handlerChange = (e: any) => {
    const { name, value } = e.target;

    // Validar el correo electrónico
    if (name === 'email') {
      setUserRegister((prevUser) => ({ ...prevUser, [name]: value }));
      setEmailError(!isValidEmail(value));
    } else if (name === 'phone') {
      setUserRegister((prevUser) => ({ ...prevUser, [name]: value }));
      setPhoneError(!isValidPhone(value))
    }
    
    if (name === 'role' && value !== 'Administrador Facultad') {
      setUserRegister((prevUser) => ({ ...prevUser, [name]: value, faculty: [] as string[] }));
    } else {
      setUserRegister((prevUser) => ({ ...prevUser, [name]: value }));
    }
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setUserRegister((prevUser) => ({ ...prevUser, [name]: checked }));
  };

  const isValidPhone = (phone: string): boolean => {
    const phoneno = /^\d+$/;
    if (phone.match(phoneno)) {
      return true
    } else {
      return false
    }
  };

  const isValidEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };


  const [country, setCountry] = useState('+57');
  const handleCountryChange = (event: any) => {
    setCountry(event.target.value);
    setUserRegister({
      ...userRegister,
      phone_code_country: event.target.value
    })
  };

  //   useEffect(()=>{
  //     async function fetchFaculties() {
  //         if(user && user.userData.institute){
  //             try {
  //                 const getFaculties = await facultyService.getAll(user.userData.institute)
  //                 setFaculties(getFaculties)
  //             } catch (error) {
  //                 console.error("Error trying to get faculties", error)
  //             }
  //         }            
  //     }
  //     fetchFaculties()
  //   },[user])

  //   useEffect(()=>{
  //     async function fetchAdminUsers() {
  //         if(role === "Super Administrador"){
  //             try {
  //                 const adminUsers = await userAdminService.getUsersAdmins()
  //                 setAdminUsers(adminUsers)
  //             } catch (error) {
  //                 console.error("Error trying to get users", error)
  //             }
  //         }else if(role === "Administrador IES" && user?.userData.institute)  {
  //           try {
  //                 const adminUsers = await userAdminService.getUsersAdminFaculty(user.userData.institute)
  //                 setAdminUsers(adminUsers)
  //           } catch (error) {
  //             console.error("Error trying to get users", error)

  //           }
  //         }          
  //     }
  //     fetchAdminUsers()
  // },[role, user?.userData.institute])

  return (
    <Box sx={{ padding: { xs: 4, sm: 5 } }}>
      <Header title="Crear usuario" subtitle="Por favor, diligencie todos los campos" />
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
        <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: "700px" }}>

          <FormGroup
            sx={{
              padding: 3,
              borderRadius: 2,
              border: `1px solid ${colors.blueAccent[500]}`,
              width: "100%",
              marginTop: "30px",
              backgroundColor: colors.primary[400],
            }}>
            <Grid container spacing={2.5} justifyContent="center">

            <Grid item xs={12} sm={10} sx={{ width: "100%" }}>
              <FormControl fullWidth size="small">
                <InputLabel id="role" sx={{ color: `${colors.grey[100]} !important`, fontSize: "16px", backgroundColor: colors.primary[400], padding: "0 2px" }}>Tipo de usuario</InputLabel>
                <Select
                  required
                  labelId="role"
                  id="role"
                  name="role"
                  size="small"
                  value={userRegister.role}
                  onChange={handlerChange}
                  sx={{ color: colors.grey[100], backgroundColor: colors.primary[400], height: "45px", fontSize: 16 }}
                >
                  <MenuItem value="Administrador Facultad" sx={{ fontSize: "16px" }}>Gestor Facultad</MenuItem>
                  <MenuItem value="Administrador IES" sx={{ fontSize: "16px" }}>Administrador IES</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {userRegister.role === "Administrador Facultad" && (
              <Grid item xs={12} sm={10} sx={{ width: "100%" }}>
                <FormControl fullWidth size="small" >
                  <InputLabel id="faculty" sx={{ color: `${colors.grey[100]} !important`, fontSize: "16px", backgroundColor: colors.primary[400], padding: "0 2px" }}>Elija la facultad</InputLabel>
                  <Select
                    id="faculty"
                    name="faculty"
                    size="small"
                    required
                    multiple
                    labelId="faculty"
                    value={Array.isArray(userRegister.faculty) ? userRegister.faculty : []}
                    onChange={handlerChange}
                    renderValue={(selected) => (selected as string[]).join(', ')}
                    open={openFacultySelect}
                    onOpen={() => setOpenFacultySelect(true)}
                    onClose={() => setOpenFacultySelect(false)}
                    sx={{
                      color: colors.grey[100],
                      height: "45px",
                      fontSize: 16,
                      width: "100%",
                      "& .MuiSelect-select": {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "block !important"
                      }
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        padding: '4px 8px',
                      }}
                    >
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenFacultySelect(false);
                        }}
                        sx={{ color: colors.grey[100] }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Box>
                    {filteredFaculties?.map((faculty) => (
                      <MenuItem key={faculty.id} value={faculty.name} sx={{ fontSize: "16px" }}>
                        <Checkbox checked={Array.isArray(userRegister.faculty) && userRegister.faculty.indexOf(faculty.name) > -1} />
                        {faculty.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            <Grid item xs={12} sm={10} sx={{ width: "100%" }}>
              <TextField
                required
                id="name"
                name="name"
                label="Nombres y Apellidos"
                fullWidth
                size="small"
                autoComplete="off"
                variant="outlined"
                value={userRegister.name}
                onChange={handlerChange}
                sx={{ color: colors.grey[100] }}
                InputLabelProps={{
                  style: {
                    color: colors.grey[100],
                    fontSize: "16px",
                    backgroundColor: colors.primary[400]
                  }
                }}
                InputProps={{
                  style: {
                    color: colors.grey[100],
                    fontSize: "16px",
                    height: "45px"
                  }
                }}
              />
            </Grid>

            <Grid item xs={12} sm={10} sx={{ width: "100%" }}>
              <TextField
                required
                type="email"
                name="email"
                id="email"
                label="Correo electrónico"
                fullWidth
                size="small"
                autoComplete="off"
                variant="outlined"
                value={userRegister.email}
                onChange={handlerChange}
                error={emailError}
                helperText={emailError ? 'El correo electrónico no es válido' : ''}
                sx={{ color: colors.grey[100] }}
                InputLabelProps={{
                  style: {
                    color: colors.grey[100],
                    fontSize: "16px",
                    backgroundColor: colors.primary[400],
                  },
                }}
                InputProps={{
                  style: { color: colors.grey[100], fontSize: "16px", height: "45px" },
                }}
              />
            </Grid>

            <Grid sx={{ gridColumn: { xs: "span 1" }, width: "100%", marginBottom: "15px" }} item xs={12} sm={10}>
              <FormControl id="phone" variant="outlined" fullWidth size="small" sx={{ display: "flex", flexDirection: "row" }}>
                <Select
                  value={country}
                  id="phone_code_country"
                  name="phone_code_country"
                  onChange={handleCountryChange}
                  sx={{ display: "flex", border: "none", width: { xs: "40%", sm: "45%" }, color: colors.grey[100], maxHeight: "46.6px", paddingRight: "30px", textOverflow: "ellipsis" }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                        width: '40ch',
                        right: 0,
                        margin: '0 0 0 24px',
                        color: colors.grey[100],
                      },
                    },
                  }}
                >
                  {dialCodes.map((country) => (
                    <MenuItem key={country.code} value={country.dial_code}>
                      <Typography variant="h5">({country.dial_code}) {country.name}</Typography>
                    </MenuItem>
                  ))}
                </Select>
                <TextField

                  id="phone"
                  name="phone"
                  label="Número de contacto"
                  fullWidth
                  size="small"
                  autoComplete="off"
                  variant="outlined"
                  value={userRegister.phone}
                  onChange={handlerChange}
                  error={phoneError}
                  helperText={phoneError ? 'Sólo se permiten números' : ''}
                  sx={{
                    color: colors.grey[100], width: { xs: "60%", sm: "55%" },
                    display: "flex"
                  }}
                  InputLabelProps={{
                    style: {
                      color: colors.grey[100],
                      fontSize: "16px",
                      backgroundColor: colors.primary[400]
                    }
                  }}
                  InputProps={{
                    style: {
                      color: colors.grey[100],
                      fontSize: "16px"
                    }
                  }}
                />
              </FormControl>

            </Grid>

            <Grid item xs={12} sm={10} sx={{ width: "100%", display: "flex", justifyContent: "flex-start" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={userRegister.autoAssign}
                    onChange={handleCheckboxChange}
                    name="autoAssign"
                    sx={{ color: colors.grey[100], '&.Mui-checked': { color: colors.blueAccent[500] } }}
                  />
                }
                label={<Typography sx={{ color: colors.grey[100] }}>Asignar contraseña automáticamente</Typography>}
              />
            </Grid>

            {!userRegister.autoAssign && (
              <>
                <Grid item xs={12} sm={10} sx={{ width: "100%" }}>
                  <TextField
                    required
                    type={showPassword ? "text" : "password"}
                    name="password"
                    id="password"
                    label="Contraseña"
                    fullWidth
                    size="small"
                    autoComplete="off"
                    variant="outlined"
                    value={userRegister.password}
                    onChange={handlerChange}
                    sx={{ color: colors.grey[100] }}
                    InputLabelProps={{
                      style: {
                        color: colors.grey[100],
                        fontSize: "16px",
                        backgroundColor: colors.primary[400],
                      },
                    }}
                    InputProps={{
                      style: { color: colors.grey[100], fontSize: "16px", height: "45px" },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                            sx={{ color: colors.grey[100] }}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={10} sx={{ width: "100%" }}>
                  <TextField
                    required
                    type="password"
                    name="confirmPassword"
                    id="confirmPassword"
                    label="Repetir contraseña"
                    fullWidth
                    size="small"
                    autoComplete="off"
                    variant="outlined"
                    value={userRegister.confirmPassword}
                    onChange={handlerChange}
                    error={userRegister.password !== userRegister.confirmPassword && userRegister.confirmPassword !== ""}
                    helperText={userRegister.password !== userRegister.confirmPassword && userRegister.confirmPassword !== "" ? 'Las contraseñas no coinciden' : ''}
                    sx={{ color: colors.grey[100] }}
                    InputLabelProps={{
                      style: {
                        color: colors.grey[100],
                        fontSize: "16px",
                        backgroundColor: colors.primary[400],
                      },
                    }}
                    InputProps={{
                      style: { color: colors.grey[100], fontSize: "16px", height: "45px" },
                    }}
                  />
                </Grid>
              </>
            )}

              <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
                <Button
                  variant="contained"
                  sx={{

                    backgroundColor: "#3F51B5",
                    color: "#f2f0f0",
                    borderRadius: "5px",
                    fontWeight: "bolder",
                    width: "fit-content",
                    ":hover": {
                      cursor: "pointer",
                      backgroundColor: colors.blueAccent[500]

                    }
                  }}
                  disabled={
                    phoneError || 
                    (!userRegister.autoAssign && (userRegister.password === "" || userRegister.password !== userRegister.confirmPassword)) ||
                    (userRegister.role === "Administrador Facultad" && (!userRegister.faculty || userRegister.faculty.length === 0))
                  }
                  type="submit"
                >
                  Crear usuario
                </Button>
              </Grid>

            </Grid>
          </FormGroup>
        </form>
      </Box>
    </Box>
  );
}
